import { z } from 'zod';
import { ContentDraftView, CreateContentDraftInput, DeleteContentDraftResult, UpdateContentDraftInput, } from '../../content-draft.js';
export const contentDraftRoutes = {
    list: { method: 'GET', path: '/me/content-drafts', response: z.array(ContentDraftView) },
    create: {
        method: 'POST',
        path: '/me/content-drafts',
        body: CreateContentDraftInput,
        response: ContentDraftView,
    },
    get: {
        method: 'GET',
        path: '/me/content-drafts/:draftId',
        response: ContentDraftView,
    },
    update: {
        method: 'PUT',
        path: '/me/content-drafts/:draftId',
        body: UpdateContentDraftInput,
        response: ContentDraftView,
    },
    remove: {
        method: 'DELETE',
        path: '/me/content-drafts/:draftId',
        response: DeleteContentDraftResult,
    },
};
//# sourceMappingURL=routes.js.map